import { render, staticRenderFns } from "./informationAdminEdit.vue?vue&type=template&id=94dfb90a&"
import script from "./informationAdminEdit.vue?vue&type=script&lang=js&"
export * from "./informationAdminEdit.vue?vue&type=script&lang=js&"
import style0 from "./informationAdminEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports